import React from 'react';
import logo from '../../assets/img/logo.png';
import { getName } from '../../helpers/user.helper';
import { getuser } from '../../helpers/user.helper';

export default function AsideLeft({ option }) {
    return (
        <>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                <a href="/vendas" className="brand-link">
                    <img src={logo} alt="Hondix Logo" />
                </a>
                <div className="sidebar">
                    <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                        <div className="image">
                            {/* <img src="dist/img/user2-160x160.jpg" className="img-circle elevation-2" alt="User Image" /> */}
                        </div>
                        <div className="info">
                            <a href="#" className="d-block">{getName()}</a>
                        </div>
                    </div>
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                            <li className="nav-item">
                                <a href="/vendas" className={`nav-link ${option === 'vendas' ? 'active' : ''}`}>
                                    <i className="fa fa-shopping-cart" />&nbsp;
                                    <p> {getuser().type === "C" ? 'Minhas Compras' : 'Minhas Vendas'}</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                {
                                    getuser().type === "A" &&
                                    <a href="/users" className={`nav-link ${option === 'users' ? 'active' : ''}`}>
                                        <i className="fa fa-user" />&nbsp;
                                        <p> Usuários</p>
                                    </a>
                                }
                            </li>

                            <li className="nav-item">
                                {
                                    getuser().type === "A" &&
                                    <a href="/pagamentos/list" className={`nav-link ${option === 'pagamentos' ? 'active' : ''}`}>
                                        <i className="fa fa-money" />&nbsp;
                                        <p> Pagamentos</p>
                                    </a>
                                }
                            </li>

                            <li className="nav-item">
                                {
                                    getuser().type === "A" &&
                                    <a href="/ficha" className={`nav-link ${option === 'ficha' ? 'active' : ''}`}>
                                        <i className="fa fa-address-card" />&nbsp;
                                        <p> Ficha</p>
                                    </a>
                                }
                            </li>
                              <li className="nav-item">
                                {
                                    getuser().type === "A" &&
                                    <a href="/pre-cadastro" className={`nav-link ${option === 'pre-cadastro' ? 'active' : ''}`}>
                                        <i className="fa fa-address-card" />&nbsp;
                                        <p> Pré-Cadastro</p>
                                    </a>
                                }
                            </li>

                            <li className="nav-item">
                                {
                                    getuser().type === "A" &&
                                    <a href="/produtos" className={`nav-link ${option === 'produtos' ? 'active' : ''}`}>
                                        <i className="fa fa-archive" />&nbsp;
                                        <p> Produtos</p>
                                    </a>
                                }
                            </li>
                            <li className="nav-item">
                                {
                                    getuser().type === "A" &&
                                    <a href="/clientes" className={`nav-link ${option === 'clientes' ? 'active' : ''}`}>
                                        <i className="fa fa-male" />&nbsp;
                                        <p> Clientes</p>
                                    </a>
                                }
                            </li>
                            <li className="nav-item">
                                {
                                    getuser().type === "A" &&
                                    <a href="/kits" className={`nav-link ${option === 'kits' ? 'active' : ''}`}>
                                        <i className="fa fa-suitcase" />&nbsp;
                                        <p> Kits</p>
                                    </a>
                                }
                            </li>


                            <li className="nav-item">
                                {
                                    getuser().type === "R" &&
                                    <a href="/clientes" className={`nav-link ${option === 'clientes' ? 'active' : ''}`}>
                                        <i className="fa fa-male" />&nbsp;
                                        <p> Meus Clientes</p>
                                    </a>
                                }
                            </li>

                            <li className="nav-item">
                                {
                                    getuser().type === "R" &&
                                    <a href="/fechamento" className={`nav-link ${option === 'fechamento' ? 'active' : ''}`}>
                                        <i className="fa fa-male" />&nbsp;
                                        <p>Fechamento de Mês</p>
                                    </a>
                                }
                            </li>

                            {/* <li className="nav-item">
                                {
                                    getuser().type === "A" &&
                                    <a href="/contas" className={`nav-link ${option === 'fechamento' ? 'active' : ''}`}>
                                        <i className="fa fa-male" />&nbsp;
                                        <p>Contas a Receber</p>
                                    </a>
                                }
                            </li>
 */}
                            <li className="nav-item">
                                <a href="/new-pass" className={`nav-link ${option === 'new-pass' ? 'active' : ''}`}>
                                    <i className="fa fa-user" />&nbsp;
                                        <p>Alterar senha</p>
                                </a>
                            </li>

                            <li className="nav-item">
                                <a href="/aplicativo" className={`nav-link ${option === 'aplicativo' ? 'active' : ''}`}>
                                    <i className="fa fa-android" />&nbsp;
                                        <p>Aplicativo</p>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>
        </>
    )
}
